
import axios from "@/config/axios"



const state = {
  usuarios:[],
  entidades:[],
  indiceEntidad:-1,
  validacionDominio:{
    "DominioValido": false,       // Si el dominio está en Entidades
    "UsuarioExistente": false,  // Si el usuario existe
    "UsuarioActivo": false,     // Si esta activo
    "CantidadUsuarios": -1,       // Configurados en Entidades
    "CantidadUsuariosActivos": -1,// Usuarios Activos
     //"Token": "-00001"           // Token si esta activo
  },  
  validacionUsuario:{
    "UsuarioExistente": false,  // Si el usuario existe
    "UsuarioActivo": false,     // Si esta activo
    //"Token": "-00001"     // Token si esta activo
  },
  usuarioConfig: {
    email:'',             // email del usuario
    esNuevoEditar: true,  // Si se esta editando o es nuevo
    desdeListado: false,    // Si es desde lista de usuarios
    indiceListado: -1       // Indice en el listado
  },
  usuario: {}   
  // // idEntidad:0,
  // // idUsuario:0,
};

const mutations = {
  setEntidades(state, entidades) {
    state.entidades = entidades;
  },
  setEntidad(state, entidad) {
    // const {indice, entidad} = payload
    state.entidades[state.indiceEntidad] = entidad;
  },
  setEntidadNva(state, entidad) {
    // const {indice, entidad} = payload
    // entidad.idEntidad = state.entidades.length + 1 
    state.entidades.push(entidad)
  },
  setIndiceEntidad(state, indiceEntidad){
    state.indiceEntidad=indiceEntidad
  },
  setValidacionDominio(state, validacionDominio){
    state.validacionDominio=validacionDominio
  },  
  setValidacionUsuario(state, validacionUsuario){
    state.validacionUsuario=validacionUsuario
  },  
  setUsuarios(state, usuarios) {
    state.usuarios = usuarios;
  },
  setUsuario(state, usuario) {
    state.usuario = usuario;
  },
  setUsuarioConfig(state, usuarioConfig){
    state.usuarioConfig = usuarioConfig;
  },
  setUsuarioListado(state, usuario) {
    // const {indice, usuario} = payload
    state.usuarios[state.usuarioConfig.indiceUsuario] = usuario;
  },
  setUsuarioNvoListado(state, usuario) {
    // const {indice, usuario} = payload
    // usuario.idUsuario = state.usuarios.length + 1 
    state.usuarios.push(usuario)
  },
  setIndiceUsuario(state, indiceUsuario){
    state.usuarioConfig.indiceUsuario=indiceUsuario
  },      
};

const actions = {
  setUsuarios({ commit }, usuarios) {
    commit("setusuarios", usuarios);
  },  
  setEntidades({ commit }, entidades) {
    commit("setentidades", entidades);
  },
  async fetchUsuario(
    { commit }, email) {
    try {
      
      console.log(`/acceso/usuario/${email}`)
      ////commit("setUsuario", {});
      let result = await axios.get(`/acceso/usuario/${email}`)
      console.log("result.data", result.data)
      commit("setUsuario", result.data);
      //console.log("setUsuario", )
    } catch (error) {
      // // dispatch("handleProcessError", error);
            
      if (err.response) {
        const error = new Error(err.response.data.Message);
        error.statusCode = err.response.data.StatusCode;
        throw error;
      }else{
        throw new Error(err);
      }
    }
  },

  async fetchUsuarios(
    { commit, dispatch }, inicializar) {
    // Si no es necesarion no reconsultar 
    // console.log('state.entidades', state.entidades.length)
    // console.log('state.entidades==[]', state.entidades==[])

    //TODO: Implementar botón de refresh
    inicializar=true
    if (state.usuarios.length === 0 || inicializar){
      try {
        
        let result = await axios.get('/acceso/usuarios').catch((err) => {
          if (err.response) {
            const error = new Error(err.response.data.Message);
            error.statusCode = err.response.data.StatusCode;
            throw error;
          }else{
            throw new Error(err);
          }
        });
        commit("setUsuarios", result.data);
      } catch (error) {
        // // dispatch("handleProcessError", error);
        alert(error)
      }
    }
  },
  async fetchEntidades({ commit, dispatch }, inicializar=false){
    // Si no es necesarion no reconsultar 
    console.log('state.entidades', state.entidades.length)
    console.log('state.entidades==[]', state.entidades==[])
    if (state.entidades.length === 0 || inicializar){
      try {
        let result = await axios.get('/acceso/entidades').catch((err) => {
          if (err.response) {
            const error = new Error(err.response.data.Message);
            error.statusCode = err.response.data.StatusCode;
            throw error;
          }else{
            throw new Error(err);
          }
        });
        commit("setEntidades", result.data);
      } catch (error) {
        // // dispatch("handleProcessError", error);
        alert(error)
      }
    }
  },
  async postEntidad({ commit, dispatch }, entidad){
    // Si no es necesarion no reconsultar 
    console.log('post entidad', entidad)
    try {
      
      let result = await axios
        .post('/acceso/entidad',
          entidad
          // {
          //   headers: {
          //     Authorization: `bearer ${rootState.auth.authUser.jwt}`,
          //   },
          // }          
        )
        .then((res) => {
          if (res.status === 200) {
            entidad.idEntidad = res.data
            commit("setEntidadNva", entidad);
          }
        })
        .catch((err) => {
        if (err.response) {
          const error = new Error(err.response.data.Message);
          error.statusCode = err.response.data.StatusCode;
          throw error;
        }else{
          throw new Error(err);
        }
      });
    } catch (error) {
      // // dispatch("handleProcessError", error);
      alert(error)
    }
  },  
  async putEntidad({ commit, dispatch }, entidad){
    // Si no es necesarion no reconsultar 
    console.log('put entidad', entidad)
    
    try {
      let result = await axios
        .put('/acceso/entidad',
          entidad
          // {
          //   headers: {
          //     Authorization: `bearer ${rootState.auth.authUser.jwt}`,
          //   },
          // }          
        )
        .then((res) => {
          if (res.status === 200) {
            commit("setEntidad", entidad);
          }
        })
        .catch((err) => {
        if (err.response) {
          const error = new Error(err.response.data.Message);
          error.statusCode = err.response.data.StatusCode;
          throw error;
        }else{
          throw new Error(err);
        }
      });
    } catch (error) {
      // // dispatch("handleProcessError", error);
      alert(error)
    }
  },  
  async validarDominioEMail({ commit, dispatch }, email){
    // Si no es necesarion no reconsultar 
    console.log('validarDominioEMail', email)
    try {
      // Inicializar validacionDominio
      commit("setValidacionDominio", {});
      let validacionDominio
      let res = await axios.get(
        `/acceso/validarDominioEMail/${email}`
          // {
          //   headers: {
          //     Authorization: `bearer ${rootState.auth.authUser.jwt}`,
          //   },
          // }          
      )

      // // if (res.status === 200) {
      // //     validacionDominio = res.data
      // //     commit("setValidacionDominio", validacionDominio);
      // // }
      validacionDominio = res.data
      //
      
      commit("setValidacionDominio", validacionDominio);
    } catch (err) {
      
      if (err.response) {
        const error = new Error(err.response.data.Message);
        error.statusCode = err.response.data.StatusCode;
      // // //   
      // // //   throw error;
      // // // }else{
      // // //   // // throw err;
      // // //   
      // // //   alert(err);
        throw error;
      }
      throw err
    }
  },
  async validarUsuario({ commit, dispatch }, email){
    // Si no es necesarion no reconsultar 
    console.log('validarUsuario', email)
    try {
      // Inicializar validacionDominio
      commit("setValidacionUsuario", {});
      let validacionUsuario
      let res = await axios.get(
        `/acceso/validarUsuario/${email}`
          // {
          //   headers: {
          //     Authorization: `bearer ${rootState.auth.authUser.jwt}`,
          //   },
          // }          
      )

      // // if (res.status === 200) {
      // //     validacionUsuario = res.data
      // //     commit("setValidacionUsuario", validacionUsuario);
      // // }
      validacionUsuario = res.data
      
      commit("setValidacionUsuario", validacionUsuario);


    } catch (err) {
      if (err.response) {
        const error = new Error(err.response.data.Message);
        error.statusCode = err.response.data.StatusCode;
      // // //   
      // // //   throw error;
      // // // }else{
      // // //   // // throw err;
      // // //   
      // // //   alert(err);
        throw error;
      }
      throw err;
    }
  }, 
  async postUsuario({ commit, state, dispatch }, usuario){

    console.log('post usuario', usuario)
    
    try {
      let result = await axios
        .post('/acceso/usuario',
          usuario
          // {
          //   headers: {
          //     Authorization: `bearer ${rootState.auth.authUser.jwt}`,
          //   },
          // }          
        )
        .then((res) => {
          if (res.status === 200) {
            usuario.idUsuario = res.data
            // Si es desde listado agregarlo al listado
            if(state.usuarioConfig.desdeListado){
              commit("setUsuarioNvoListado", usuario);
            }
          }
          dispatch("process/showNotifier", {
            message: 'Usuario guardado satisfactoriamente',
            type: 'success'
          },
          {root: true}
        )          
        })
      } catch (err) {
        dispatch("process/showNotifier", 
        {error: err},
        {root: true}
      );	

    }
  },  
  async putUsuario({ commit, dispatch }, usuario){
    // Si no es necesarion no reconsultar 
    console.log('put usuario', usuario)
    try {
      let res = await axios
        .put('/acceso/usuario',
          usuario,
          // // {
          // //   headers: {
          // //     Authorization: `bearer ${rootState.auth.authUser.jwt}`,
          // //   },
          // // }          
        )
      if (res.status === 200) {
        commit("setUsuario", usuario);
        dispatch("process/showNotifier", {
            message: 'Usuario guardado satisfactoriamente',
            type: 'success'
          },
          {root: true}
        )        
      } else {
        dispatch("process/showNotifier", {
          message: 'No se pudo guardar el Usuario',
          type: 'warnign'
        },
        {root: true}
      )        
    }
    } catch (err) {
      dispatch("process/showNotifier", 
      {error: err},
      {root: true}
    )}
  },   
  async putUsuarioAdmin({ commit, dispatch }, usuario){
    // Si no es necesarion no reconsultar 
    console.log('put usuario', usuario)
    
    try {
      let res = await axios
        .put('/acceso/usuario-admin',
          usuario,
          // // {
          // //   headers: {
          // //     Authorization: `bearer ${rootState.auth.authUser.jwt}`,
          // //   },
          // // }          
        )
      if (res.status === 200) {
        commit("setUsuario", usuario);
        dispatch("process/showNotifier", {
            message: 'Usuario guardado satisfactoriamente',
            type: 'success'
          },
          {root: true}
        )        
      } else {
        dispatch("process/showNotifier", {
          message: 'No se pudo guardar el Usuario',
          type: 'warnign'
        },
        {root: true}
      )        
    }
    } catch (err) {
      dispatch("process/showNotifier", 
      {error: err},
      {root: true}
    )}
  },   
  
};

const getters = {
  getUsuarios(state) {
    return state.usuarios ? state.usuarios : [];
  },
  getUsuario(state) {
    return state.usuario ? state.usuario : [];
  },
  getEntidades(state) {
    return state.entidades ? state.entidades : [];
  },
  getValidacionDominio(state){
    return state.validacionDominio 
      ? state.validacionDominio : {}
  },
  getValidacionUsuario(state){
    return state.validacionUsuario 
      ? state.validacionUsuario : {}
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
